import { assertPacket } from './asserts';
import { ReplyType } from './types';
export class ReplyPacket {
    constructor(block) {
        assertPacket(block, 2 /* Reply */);
        this.data = Buffer.from(block.slice(0x03, -1));
        Object.freeze(this);
        Object.seal(this);
    }
    toType() {
        const type = this.data.toString('hex');
        if (Object.values(ReplyType).includes(type)) {
            return type;
        }
        return;
    }
}
